import { render, staticRenderFns } from "./NormalSearchNav153.vue?vue&type=template&id=0ddfaceb&scoped=true"
import script from "./NormalSearchNav153.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav153.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfaceb",
  null
  
)

export default component.exports